import type { CollectionResponseDtoRarity } from '~/lib/api';

export const getRarityVariant = (rarity: CollectionResponseDtoRarity) => {
  if (rarity === 'common') return 'common';
  if (rarity === 'uncommon') return 'uncommon';
  if (rarity === 'rare') return 'rare';
  if (rarity === 'ultra_rare') return 'ultra-rare';
  if (rarity === 'ultimate') return 'ultimate';
  if (rarity === 'heirloom') return 'heirloom';
  return 'secret-rare';
};
